import React from 'react'
import { useNavigate } from '@tanstack/react-router'

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children?: React.ReactNode
  prefetch?: boolean
}

export default function Link({ href, prefetch: _prefetch, children, onClick, ...rest }: LinkProps) {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e)
    if (!e.defaultPrevented && !href.startsWith('http') && !href.startsWith('//') && !href.startsWith('mailto:')) {
      e.preventDefault()
      navigate({ to: href as any })
    }
  }

  return (
    <a href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  )
}
